import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const icons = {
  dashboard: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M8 17H16M11.02 2.76L4.24 8.04c-.45.35-.68.53-.85.75a2.5 2.5 0 0 0-.32.65C3 9.7 3 9.99 3 10.57V17.8c0 1.12 0 1.68.22 2.11a2 2 0 0 0 .87.87C4.52 21 5.08 21 6.2 21h11.6c1.12 0 1.68 0 2.11-.22a2 2 0 0 0 .87-.87c.22-.43.22-.99.22-2.11v-7.23c0-.58 0-.87-.07-1.13a2.5 2.5 0 0 0-.32-.65c-.17-.22-.4-.4-.85-.75L12.98 2.76c-.35-.27-.53-.41-.72-.46a1.5 1.5 0 0 0-.52 0c-.19.05-.37.19-.72.46Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  visa: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 10h18M7 15h4" strokeLinecap="round" />
    </svg>
  ),
  list: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" strokeLinecap="round" />
    </svg>
  ),
  users: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  building: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-4h6v4M9 9h.01M15 9h.01M9 13h.01M15 13h.01" strokeLinecap="round" />
    </svg>
  ),
  chart: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M4 19V5M4 19h16M8 17V10M12 17V7M16 17v-4" strokeLinecap="round" />
    </svg>
  ),
  wallet: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M3 7h15a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7Z" />
      <path d="M3 7V6a2 2 0 0 1 2-2h12" />
      <circle cx="17" cy="13.5" r="1" fill="#667085" stroke="none" />
    </svg>
  ),
  settings: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" strokeLinecap="round" />
    </svg>
  ),
  alert: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" strokeLinecap="round" />
    </svg>
  ),
  check: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M20 6 9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  assign: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M16 3h5v5M8 21H3v-5M21 3l-7 7M3 21l7-7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  api: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2">
      <path d="M10 13a5 5 0 0 0 7.07 0l2.12-2.12a5 5 0 0 0-7.07-7.07L11 5" strokeLinecap="round" />
      <path d="M14 11a5 5 0 0 0-7.07 0L4.8 13.12a5 5 0 0 0 7.07 7.07L13 19" strokeLinecap="round" />
    </svg>
  ),
};

const getIconKey = (label) => {
  const value = label.toLowerCase();
  if (value.includes('dashboard')) return 'dashboard';
  if (value.includes('error')) return 'alert';
  if (value.includes('finalize')) return 'check';
  if (value.includes('assign') || value.includes('reassign')) return 'assign';
  if (value.includes('airline')) return 'building';
  if (value.includes('manager')) return 'users';
  if (value.includes('report')) return 'chart';
  if (value.includes('billing') || value.includes('balance') || value.includes('minimum')) return 'wallet';
  if (value.includes('profile')) return 'settings';
  if (value.includes('api')) return 'api';
  if (value.includes('visa')) return 'visa';
  return 'list';
};

const Sidebar = ({ open, onClose }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const getNavigation = () => {
    switch (user?.role) {
      case 'super_admin':
        return {
          title: 'Super Admin',
          links: [
            { path: '/super-admin/dashboard', label: 'Dashboard' },
            { path: '/super-admin/assign-me', label: 'Assign Me' },
            { path: '/super-admin/visa-applications', label: 'Visa Applications' },
            { path: '/super-admin/error-pool', label: 'Error Pool' },
            { path: '/super-admin/finalize-pool', label: 'Finalize Pool' },
            { path: '/super-admin/reassign', label: 'Reassign' },
            { path: '/super-admin/airlines', label: 'Airlines' },
            { path: '/super-admin/managers', label: 'Managers' },
            { path: '/super-admin/currency-minimum-balances', label: 'Minimum Balances' },
            { path: '/super-admin/reports', label: 'Reports' },
          ],
        };
      case 'manager':
        return {
          title: 'Manager',
          links: [
            { path: '/manager/dashboard', label: 'Dashboard' },
            { path: '/manager/assign-me', label: 'Assign Me' },
            { path: '/manager/visa-applications', label: 'Visa Applications' },
            { path: '/manager/error-pool', label: 'Error Pool' },
            { path: '/manager/finalize-pool', label: 'Finalize Pool' },
            { path: '/manager/reports', label: 'Reports' },
          ],
        };
      case 'airlines_admin':
        return {
          title: 'Airlines Admin',
          links: [
            { path: '/airlines-admin/dashboard', label: 'Dashboard' },
            { path: '/airlines-admin/visa-applications', label: 'Visa Applications' },
            { path: '/airlines-admin/error-pool', label: 'Error Pool' },
            { path: '/airlines-admin/finalize-pool', label: 'Finalize Pool' },
            { path: '/airlines-admin/managers', label: 'Managers' },
            { path: '/airlines-admin/reports', label: 'Reports' },
            { path: '/airlines-admin/api-integration', label: 'API Integration' },
            { path: '/airlines-admin/profile', label: 'Profile' },
            { path: '/airlines-admin/billing', label: 'Billing & Payments' },
          ],
        };
      case 'airlines_manager':
        return {
          title: 'Airlines Manager',
          links: [
            { path: '/airlines-manager/dashboard', label: 'Dashboard' },
            { path: '/airlines-manager/visa-applications', label: 'Visa Applications' },
            { path: '/airlines-manager/error-pool', label: 'Error Pool' },
            { path: '/airlines-manager/finalize-pool', label: 'Finalize Pool' },
            { path: '/airlines-manager/reports', label: 'Reports' },
          ],
        };
      default:
        return { title: 'Panel', links: [] };
    }
  };

  const nav = getNavigation();

  const go = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/40 z-40 lg:hidden transition-opacity ${
          open ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      />

      <aside
        className={`fixed top-0 left-0 bottom-0 z-50 w-[250px] bg-white border-r border-border flex flex-col transition-transform duration-[450ms] ease-[cubic-bezier(.4,0,.2,1)] lg:translate-x-0 ${
          open ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="px-3 pt-6 pb-4">
          <button type="button" onClick={() => go(nav.links[0]?.path || '/')} className="block mx-auto">
            <img src="/vughylogo.svg" alt="Vughy" className="h-9 w-auto mx-auto" />
          </button>
          <p className="mt-3 text-center text-[11px] font-medium text-ink-muted uppercase tracking-wide">
            {nav.title}
          </p>
        </div>

        <nav className="flex-1 overflow-y-auto px-2.5 pb-4 space-y-1">
          {nav.links.map((link) => {
            const active = location.pathname === link.path;
            return (
              <button
                key={link.path}
                type="button"
                onClick={() => go(link.path)}
                className={`sidebar-link ${active ? 'active' : ''}`}
              >
                {icons[getIconKey(link.label)]}
                <span>{link.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
